var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    _vm._l(_vm.dateRanges, function (dateRange, index) {
      return _c(
        "v-row",
        {
          key: index,
          staticClass: "mb-2 mt-2",
          attrs: { "no-gutters": "", align: "center" },
        },
        [
          _c(
            "v-col",
            {
              staticClass: "pr-2",
              staticStyle: { width: "160px" },
              attrs: { cols: "auto" },
            },
            [
              _c(
                "v-menu",
                {
                  attrs: {
                    "close-on-content-click": false,
                    transition: "scale-transition",
                    "offset-y": "",
                    "min-width": "auto",
                  },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "activator",
                        fn: function ({ on, attrs }) {
                          return [
                            _c(
                              "v-text-field",
                              _vm._g(
                                _vm._b(
                                  {
                                    attrs: {
                                      label: "From",
                                      readonly: "",
                                      outlined: "",
                                      dense: "",
                                      "hide-details": "",
                                    },
                                    model: {
                                      value: dateRange.from,
                                      callback: function ($$v) {
                                        _vm.$set(dateRange, "from", $$v)
                                      },
                                      expression: "dateRange.from",
                                    },
                                  },
                                  "v-text-field",
                                  attrs,
                                  false
                                ),
                                on
                              )
                            ),
                          ]
                        },
                      },
                    ],
                    null,
                    true
                  ),
                  model: {
                    value: dateRange.fromMenuOpen,
                    callback: function ($$v) {
                      _vm.$set(dateRange, "fromMenuOpen", $$v)
                    },
                    expression: "dateRange.fromMenuOpen",
                  },
                },
                [
                  _vm._v(" "),
                  _c("v-date-picker", {
                    attrs: { max: dateRange.to },
                    on: {
                      input: function ($event) {
                        dateRange.fromMenuOpen = false
                      },
                    },
                    model: {
                      value: dateRange.from,
                      callback: function ($$v) {
                        _vm.$set(dateRange, "from", $$v)
                      },
                      expression: "dateRange.from",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-col",
            {
              staticClass: "pr-2",
              staticStyle: { width: "160px" },
              attrs: { cols: "auto" },
            },
            [
              _c(
                "v-menu",
                {
                  attrs: {
                    "close-on-content-click": false,
                    transition: "scale-transition",
                    "offset-y": "",
                    "min-width": "auto",
                  },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "activator",
                        fn: function ({ on, attrs }) {
                          return [
                            _c(
                              "v-text-field",
                              _vm._g(
                                _vm._b(
                                  {
                                    attrs: {
                                      label: "To",
                                      readonly: "",
                                      outlined: "",
                                      dense: "",
                                      "hide-details": "",
                                    },
                                    model: {
                                      value: dateRange.to,
                                      callback: function ($$v) {
                                        _vm.$set(dateRange, "to", $$v)
                                      },
                                      expression: "dateRange.to",
                                    },
                                  },
                                  "v-text-field",
                                  attrs,
                                  false
                                ),
                                on
                              )
                            ),
                          ]
                        },
                      },
                    ],
                    null,
                    true
                  ),
                  model: {
                    value: dateRange.toMenuOpen,
                    callback: function ($$v) {
                      _vm.$set(dateRange, "toMenuOpen", $$v)
                    },
                    expression: "dateRange.toMenuOpen",
                  },
                },
                [
                  _vm._v(" "),
                  _c("v-date-picker", {
                    attrs: { min: dateRange.from },
                    on: {
                      input: function ($event) {
                        dateRange.toMenuOpen = false
                      },
                    },
                    model: {
                      value: dateRange.to,
                      callback: function ($$v) {
                        _vm.$set(dateRange, "to", $$v)
                      },
                      expression: "dateRange.to",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-col",
            { staticClass: "text-center", attrs: { cols: "auto" } },
            [
              _c(
                "v-btn",
                {
                  attrs: {
                    icon: "",
                    small: "",
                    disabled: _vm.dateRanges.length === 1 || _vm.disabled,
                    title: "Remove date range",
                  },
                  on: {
                    click: function ($event) {
                      return _vm.removeDateRange(index)
                    },
                  },
                },
                [_c("v-icon", { attrs: { small: "" } }, [_vm._v("close")])],
                1
              ),
              _vm._v(" "),
              _c(
                "v-btn",
                {
                  attrs: {
                    icon: "",
                    small: "",
                    disabled: _vm.disabled,
                    title: "Add date range",
                  },
                  on: {
                    click: function ($event) {
                      return _vm.addDateRange(index)
                    },
                  },
                },
                [_c("v-icon", { attrs: { small: "" } }, [_vm._v("add")])],
                1
              ),
            ],
            1
          ),
        ],
        1
      )
    }),
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }